import { Box, Button, MenuItem, Tab } from '@mui/material';
import { ActionsMenu, TabBar } from '@tix-ticketing/ui-components';
import { SettingsIcon } from '@tix-ticketing/ui-icons/outline';
import { useState } from 'react';
import { themePresets, type ThemePresetId } from 'lib/app-configs';
import { useColorSchemeOverride, useThemeOverride, type ColorSchemeOverride } from 'lib/theme-config';
const presetIds = Object.keys(themePresets) as ThemePresetId[];
const presetLabels: Record<ThemePresetId, string> = {
  default: 'Fictional',
  alternative: 'Alternative',
  desingel: 'Desingel'
};
const modes: {
  value: ColorSchemeOverride | null;
  label: string;
}[] = [{
  value: null,
  label: 'Auto (default)'
}, {
  value: 'light',
  label: 'Light'
}, {
  value: 'dark',
  label: 'Dark'
}];
type ConfigTab = 'themes' | 'mode';

/** DEV-only: swaps a hardcoded preset in over the tenant's proxy theme, and
 *  forces the light or dark scheme. */
export function AppConfigSelector() {
  const [override, setOverride] = useThemeOverride();
  const [mode, setMode] = useColorSchemeOverride();
  const [tab, setTab] = useState<ConfigTab>('themes');
  return <ActionsMenu button={<Button color="monochrome" startIcon={<SettingsIcon />} sx={() => ({
    display: {
      xs: 'none',
      md: 'inline-flex'
    },
    pl: 1.4,
    pr: 1.4,
    '.MuiButton-startIcon': {
      mr: 1.5,
      ml: 0
    }
  })}>
          Config
        </Button>}>
      {/* A render function keeps the menu open while switching tabs; the
          items close it themselves. */}
      {close => <>
          <Box sx={{
        px: 2,
        mb: 1
      }}>
            <TabBar size="small" value={tab} onChange={(_, value: ConfigTab) => setTab(value)}>
              <Tab value="themes" label="Themes" />
              <Tab value="mode" label="Mode" />
            </TabBar>
          </Box>
          {tab === 'themes' ? <>
              <MenuItem selected={override === null} onClick={() => {
          setOverride(null);
          close();
        }}>
                Proxy (default)
              </MenuItem>
              {presetIds.map(id => <MenuItem key={id} selected={override === id} onClick={() => {
          setOverride(id);
          close();
        }}>
                  {presetLabels[id]}
                </MenuItem>)}
            </> : modes.map(({
        value,
        label
      }) => <MenuItem key={label} selected={mode === value} onClick={() => {
        setMode(value);
        close();
      }}>
                {label}
              </MenuItem>)}
        </>}
    </ActionsMenu>;
}